import { render, staticRenderFns } from "./Achizitii.vue?vue&type=template&id=a83886e0"
import script from "./Achizitii.vue?vue&type=script&lang=js"
export * from "./Achizitii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports